import { render, staticRenderFns } from "./ProductInfoImportant.vue?vue&type=template&id=fffdeb44&scoped=true&"
import script from "./ProductInfoImportant.vue?vue&type=script&lang=js&"
export * from "./ProductInfoImportant.vue?vue&type=script&lang=js&"
import style0 from "./ProductInfoImportant.vue?vue&type=style&index=0&id=fffdeb44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fffdeb44",
  null
  
)

export default component.exports